"use client";

import { c as _c } from "react/compiler-runtime";
import { PropertyOverlay } from "@/components/common/property-overlay/property-overlay";
import { ErrorBoundary } from "@/components/error-boundary";
import { useFavoritesInitialization } from "@/hooks/use-favorites";
import { useUrlState } from "@/hooks/use-url-state";
import { useSearchPageInteraction } from "@/providers/search";
import { useViewedPropertiesInitialization } from "@/providers/search/hooks/use-viewed-properties";
import React from "react";
import { SearchContentFallback } from "./fallback";
import { DesktopLayout } from "./layout/desktop";
import { MobileLayout } from "./layout/mobile";
export const Content = function Content() {
  const $ = _c(9);
  const view = useSearchPageInteraction(_temp);
  useSearchPageInteraction(_temp2);
  useFavoritesInitialization();
  useViewedPropertiesInitialization();
  const {
    setView: setUrlView
  } = useUrlState();
  let t0;
  if ($[0] !== setUrlView) {
    t0 = newView => {
      setUrlView(newView);
    };
    $[0] = setUrlView;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleViewChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden md:flex w-full h-full"><DesktopLayout /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handleViewChange || $[4] !== view) {
    t2 = <div className="md:hidden w-full h-full relative"><MobileLayout view={view} onViewChange={handleViewChange} /></div>;
    $[3] = handleViewChange;
    $[4] = view;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PropertyOverlay isForPreference={false} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <ErrorBoundary fallback={SearchContentFallback}><div className="flex flex-col lg:flex-row w-full h-full">{t1}{t2}{t3}</div></ErrorBoundary>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(state) {
  return state.view;
}
function _temp2(state_0) {
  return state_0.setView;
}